import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import Bus from 'EurestoClass/Bus'
import {Waypoint} from 'react-waypoint'

export default React.memo(props =>
  props.showLoader && props.isLoading && <CircularProgress size={20} thickness={4} className={'EurestoPrimary--text'}/>
  ||
  (
    !props.over &&
    !props.isLoading
  ) && <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
    if (previousPosition !== currentPosition) {
      Bus.$emit('infinityScroll_search_' + props.search, true)
    }
  }}/> || <div style={{ display: 'none' }}/>
)



// WEBPACK FOOTER //
// ./app/Components/EurestoInfinityScroll.js